import {
  PrivateBlogCategoryEntity,
} from './privateBlogCategoryEntity';
import { Category } from './valueObjects/category';
import { CategoryId } from './valueObjects/categoryId';
import { CategoryIndex } from './valueObjects/categoryIndex';

import type {
  PrivateBlogCategoryProps,
} from './privateBlogCategoryEntity';
import type { PrivateBlogCategoryJson } from '@/types/domain/privateBlog/entities/privateBlogCategoryEntity';

import { Factory } from '@/domain/factory';

export class PrivateBlogCategoryFactory extends Factory<
  PrivateBlogCategoryEntity,
  PrivateBlogCategoryProps,
  PrivateBlogCategoryJson
> {
  /**
   * 比較
   * @param a 対象1
   * @param b 対象2
   * @returns 差分
   */
  comparePvt = (a: PrivateBlogCategoryJson, b: PrivateBlogCategoryJson) => {
    const da = a.categoryIndex;
    const db = b.categoryIndex;
    return da > db ? 1 : -1;
  };

  /**
   * Entityを生成する
   * @param props プロパティ
   * @returns Entity
   */
  createPvt(props: PrivateBlogCategoryProps): PrivateBlogCategoryEntity {
    return new PrivateBlogCategoryEntity(props, null);
  }

  /**
   * JsonからEntityを生成する
   * @param props Json
   * @returns Entity
   */
  createFromJsonPvt(props: PrivateBlogCategoryJson): PrivateBlogCategoryEntity {
    return this.createPvt({
      categoryId: CategoryId.create(props.categoryId),
      categoryIndex: CategoryIndex.create(props.categoryIndex),
      category: Category.create(props.category),
    });
  }
}
